import ReactDOM from "react-dom";
import "./assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/scss/argon-dashboard-react.scss";
import "./assets/css/deskcoach.css";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
